//* Products
export const GET_PRODUCT = "product";
export const GET_ALL_PRODUCTS = "all-products";
export const GET_PAGINATED_PRODUCTS = "paginated-products";

//* Product SKUs
export const GET_PRODUCT_SKU = "product-sku";
export const GET_ALL_PRODUCT_SKUS = "all-product-skus";
export const GET_DROPDOWN_PRODUCT_SKUS = "dropdown-product-skus";
export const GET_PAGINATED_PRODUCT_SKUS = "paginated-product-skus";

//* Product Packs
export const GET_PRODUCT_PACK = "product-pack";
export const GET_PRODUCT_PACK_CSV = "product-pack-csv";

//* Product Groups
export const GET_ALL_PRODUCT_GROUPS = "all-product-groups";
export const GET_PAGINATED_PRODUCT_GROUPS = "paginated-product-groups";
export const GET_SINGLE_PRODUCT_GROUP = "single-product-group";

//* Brands
export const GET_ALL_BRANDS = "all-brands";
export const GET_SINGLE_BRAND = "single-brand";
export const GET_PAGINATED_BRANDS = "paginated-brands";
export const GET_PRODUCTS_FROM_BRAND = "products-from-brand";
export const GET_PRODUCT_SKUS_FROM_BRAND = "product-skus-from-brand";

//* Categories
export const GET_ALL_CATEGORIES = "all-categories";
export const GET_PAGINATED_CATEGORIES = "paginated-categories";
export const GET_SINGLE_CATEGORY = "single-category";
export const GET_CATEGORY_PRODUCTS = "category-products";
export const GET_CATEGORY_PRODUCT_SKU = "category-product-sku";

//* Loyalty Policies
export const GET_ALL_LOYALTIES = "all-loyalties";

//* tickets
export const GET_ALL_TICKETS = "all-tickets";
export const GET_TICKET = "single-ticket";
export const GET_TICKET_METRICS = "ticket-metrics";

//* Users
export const GET_USERS = "all-users";
export const GET_ADMIN_USER = "admin-users";

// * User Groups
export const GET_USER_GROUPS = "all-user-groups";
export const GET_USER_GROUPS_BY_ID = "user-groups-by-id";
export const GET_PERMISSIONS = "permissions";

// * Orders
export const GET_ORDERS = "all-orders";
export const GET_ORDER_METRICS = "order-metrics";
export const GET_PAGINATED_ORDERS = "paginated-orders";
export const GET_ASSIGNED_ORDERS = "assigned-orders";
export const GET_USER_ORDERS = "user-orders";

//* Baskets
export const GET_BASKETS = "all-baskets";
export const GET_USER_BASKET = "user-basket";

// * Notifications
export const GET_NOTIFICATIONS = "all-notifications";
export const GET_NOTIFICATION_GROUPS = "notification-groups";

// * Dashboard
export const GET_TICKETS_ASSIGNED = "tickets-assigned-to-me";
export const GET_ORDERS_ASSIGNED = "orders-assigned-to-me";

// * Addresses
export const GET_ADDRESSES = "get-addresses";
export const GET_ADDRESS_BY_ID = "get-address-by-id";
export const GET_META_CITY_ADDRESS = "get-meta-city-address";

// * Tutorials
export const GET_TAGLISTS = "taglists";
export const GET_PAGINATED_TAGLISTS = "taglists-paginated";
export const GET_TUTORIALS = "tutorials";
export const GET_PAGINATED_TUTORIALS = "tutorials-paginated";
export const GET_TUTORIALS_BY_ID = "tutorials-by-id";
export const GET_TAGLISTS_BY_ID = "tutorial-tags-by-id";

// *About us
export const GET_VIDEO_LINKS = "videolinks";
export const GET_VIDEO_LINK_BY_ID = "videolink-by-id";
export const GET_CUSTOMER_STORIES = "customer-stories";
export const GET_CUSTOMER_STORY_BY_ID = "customer-stories-by-id";

// *FAQ Groups
export const GET_FAQ_GROUPS = "faqgroups";
export const GET_PAGINATED_FAQ_GROUPS = "faqgroups-paginated";
export const GET_FAQ_GROPUS_BY_ID = "faqgroups-by-id";

// *FAQS
export const GET_FAQS = "faqs";
export const GET_FAQS_BY_ID = "faqs-by-id";

// *Promotions
export const GET_PROMOTIONS = "promotions";
export const GET_PAGINATED_PROMOTIONS = "promotions-paginated";
export const GET_PROMOTIONS_BY_ID = "promotions-by-id";

// *Promotions Banners
export const GET_PROMOTIONS_BANNERS = "promotions-banners";
export const GET_PROMOTIONS_BANNERS_BY_ID = "promotions-banners-by-id";

// *Loyalty Redeem
export const GET_LOYALTY_REDEEM_ARCHIVED_SPECIAL =
  "loyalty-redeem-archived-special";
export const GET_LOYALTY_REDEEM_ARCHIVED_RASAN =
  "loyalty-redeem-archived-rasan";
export const GET_LOYALTY_REDEEM_UNARCHIVED_SPECIAL =
  "loyalty-redeem-unarchived-special";
export const GET_LOYALTY_REDEEM_UNARCHIVED_RASAN =
  "loyalty-redeem-unarchived-rasan";
export const GET_LOYALTY_REDEEM_BY_ID = "loyalty-redeem-by-id";

// *Lucky Draw
export const GET_LUCKY_DRAW = "lucky-draw";
export const GET_PAGINATED_LUCKY_DRAW = "lucky-draw-paginated";
export const GET_LUCKY_DRAW_BY_ID = "lucky-draw-by-id";

// *BrandAnalytics
export const GET_PRODUCT_ANALYTICS = "product-analytics";
export const GET_BRAND_ANALYTICS = "brand-analytics";
export const GET_CATEGORY_ANALYTICS = "category-analytics";
export const GET_PRODUCTSKU_ANALYTICS = "productsku-analytics";
export const GET_ORDER_ANALYTICS = "order-analytics";
